    if(typeof Checkout != "undefined"){
        (function ($) {
            function checkout() {
                addPromoCodeForm();
                addGiftCardForm();
                submitGiftCard();
                submitPromoCode();
            }

            const debounce = (callback, wait) => {
                let timeoutId = null;
                return (...args) => {
                    window.clearTimeout(timeoutId);
                    timeoutId = window.setTimeout(() => {
                        callback.apply(null, args);
                    }, wait);
                };
            }
            // addGiftCardForm
            // add dummy 'gift card' form section
            // and bind all its related funcs
            function addGiftCardForm() {
                let gift_card_form = `
                    <form id="checkout-ap21-giftCard-form">
                        <div class="checkout-giftCard-container" data-flag="initial">
                            <div class="checkout-giftCard-title">Apply Gift Card</div>
                            <div class="checkout-giftCard-inputContainer">
                                <input class="checkout-giftCard-input checkout-giftCard-cardInput" placeholder="Gift Card No." type="text" />
                                <label class="checkout-giftCard-label">Gift Card No.</label>
                            </div>
                            <div class="checkout-giftCard-inputBtnContainer">
                                <div class="checkout-giftCard-pinInputContainer">
                                    <input class="checkout-giftCard-input checkout-giftCard-pinInput" maxlength="4" placeholder="4 Digit PIN" type="number" />
                                    <label class="checkout-giftCard-label">4 Digit PIN</label>
                                </div>
                                    <button id="checkout-giftCard-btn" class="checkout-giftCard-btn" disabled>
                                        <span class="checkout-giftCard-btnContent">Apply</span>
                                        <svg class="icon-svg icon-svg--size-18 btn__spinner icon-svg--spinner-button" aria-hidden="true" focusable="false"> <use xlink:href="#spinner-button"></use> </svg>
                                        <svg class="icon-svg icon-svg--size-16 btn__icon shown-on-mobile" aria-hidden="true" focusable="false"> <use xlink:href="#arrow"></use> </svg>
                                    </button>
                            </div>
                            <div class="checkout-giftCard-msgContainer">
                                <p class="checkout-giftCard-error"></p>
                            </div>
                        </div>
                    </form>
                `;

                $('#checkout-giftCard-section').append(gift_card_form);
                $('.checkout-giftCard-cardInput').on('keydown', debounce(e => {
                    showInputLabel(e);
                    enableDisableGiftCardBtn(e)
                }, 150))
                $('.checkout-giftCard-pinInput').on('keydown', debounce(e => {
                    showInputLabel(e);
                    enableDisableGiftCardBtn(e)
                }, 150));

                $('.checkout-giftCard-cardInput').on('blur', e => {
                    hideInputLabel(e, 'cardInput');
                });
                $('.checkout-giftCard-pinInput').on('blur', e => {
                    hideInputLabel(e, 'pinInput');
                });
            }

            // showInputLabel
            // show dummy 'gift card/promo code' section's inputs' label
            // and remove its placeholder when its active
            function showInputLabel(e) {
                if (!!$(e.currentTarget).val()) {
                    $(e.currentTarget).attr('placeholder', '');
                    $(e.currentTarget).addClass('show-label');
                    $(e.currentTarget).next().addClass('show-label');
                }
            }

            // hideInputLabel
            // hide dummy 'gift card/promo code' section's inputs' label
            // and add its placeholder when its blur
            function hideInputLabel(e, flag) {
                if (!$(e.currentTarget).val()) {
                    if (flag == 'cardInput') {
                        $(e.currentTarget).attr('placeholder', 'Gift Card No.');
                    } else if (flag == 'pinInput') {
                        $(e.currentTarget).attr('placeholder', '4 Digit PIN');
                    } else if (flag == 'codeInput') {
                        $(e.currentTarget).attr('placeholder', 'Discount Code');
                    }
                    $(e.currentTarget).removeClass('show-label');
                    $(e.currentTarget).next().removeClass('show-label');
                }
            }

            // afterSubmitForm
            // after submit dummy 'gift card' form section
            // will check its inputs, labels, placeholders, and error msg
            // and enable/disable its btn
            function afterSubmitForm() {
                let temp_interval = setInterval(() => {
                    if (!$('.order-summary__section--discount .edit_checkout .field__input-btn').hasClass('btn--loading')) {
                        let error_msg = $('#error-for-reduction_code').length && $('#error-for-reduction_code')[0]?.innerText.replace(/discount code or /, '');
                        $('.checkout-giftCard-container .checkout-giftCard-error')[0].innerText = error_msg ? error_msg : '';

                        $('.checkout-giftCard-cardInput').prop('disabled', false);
                        $('.checkout-giftCard-pinInput').prop('disabled', false);

                        $('.checkout-giftCard-cardInput').val('');
                        $('.checkout-giftCard-cardInput').removeClass('show-label');
                        $('.checkout-giftCard-cardInput').next().removeClass('show-label');
                        $('.checkout-giftCard-cardInput').attr('placeholder', 'Gift Card No.');

                        $('.checkout-giftCard-pinInput').val('');
                        $('.checkout-giftCard-pinInput').removeClass('show-label');
                        $('.checkout-giftCard-pinInput').next().removeClass('show-label');
                        $('.checkout-giftCard-pinInput').attr('placeholder', '4 Digit PIN');

                        $('#checkout-giftCard-btn').removeClass('btn-submitting');
                        $('.checkout-giftCard-container').removeClass('btn-submitting');

                        enableDisableGiftCardBtn();
                        clearInterval(temp_interval);
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(temp_interval)
                }, 10000);
            }

            // enableDisableGiftCardBtn
            // enable or disbale dummy 'gift card' form section's submit btn
            function enableDisableGiftCardBtn() {
                let card_val = $('.checkout-giftCard-cardInput').val();
                let pin_val = $('.checkout-giftCard-pinInput').val();
                let btn_apply = $('#checkout-giftCard-btn');

                if (!!card_val && !!pin_val) {
                    btn_apply.prop('disabled', false);
                } else {
                    btn_apply.prop('disabled', true);
                }
            }

            // submitGiftCard
            // submit dummy gift card to validate 'gift card no.' and 'pin'
            // if its valid, then apply the return code to checkout
            // if its not valid, then show error msg
            // if it has been applied already, then will remove the added code, then add the returned new one
            function submitGiftCard() {
                $('body').on('submit', '#checkout-ap21-giftCard-form', e => {
                    e.preventDefault();
                    $('#checkout-giftCard-btn').addClass('btn-submitting');
                    $('.checkout-giftCard-container').addClass('btn-submitting');
                    $('.checkout-giftCard-cardInput').prop('disabled', true);
                    $('.checkout-giftCard-pinInput').prop('disabled', true);
                    $('.checkout-giftCard-container .checkout-giftCard-error')[0].innerText = '';

                    let card_val = $('.checkout-giftCard-cardInput').val();
                    let pin_val = $('.checkout-giftCard-pinInput').val();

                    let target_url = `https://we82o2s2ab.execute-api.ap-southeast-2.amazonaws.com/development/public/v1/giftcard`;
                    const store = ""
                    const currency = "";
                    let temp_data = {
                        "store_id": store.split('.')[0],
                        "voucher_number": card_val,
                        "pin": pin_val,
                        "currency": currency
                    }

                    let after_func = (temp_resCode) => {
                        $('#checkout_reduction_code').val(temp_resCode);
                        $('.order-summary__section--discount .edit_checkout .field__input-btn').prop('disabled', false);
                        $('.order-summary__section--discount .edit_checkout .field__input-btn').click();
                        afterSubmitForm(temp_resCode);
                    }
                    $.ajax({
                        method: 'POST',
                        url: target_url,
                        data: temp_data,
                        success: res => {
                            let ajax_resCode = res.code;
                            let disabled_code = res.disabled_code;
                            let existing_applied_codes = localStorage.getItem('existing_applied_codes');
                            localStorage.setItem('existing_applied_codes', existing_applied_codes + ', ' + ajax_resCode);
                            if (disabled_code) {
                                if (existing_applied_codes && existing_applied_codes.indexOf(disabled_code) != -1) {
                                    let code_last4 = disabled_code.substr(disabled_code.length - 4).toLowerCase();
                                    let all_tags = $('.order-summary__section--discount .tags-list .tag');
                                    let target_tag = '';
                                    let inner_target_tag = '';
                                    let no_match_tag_flag = true;
                                    let no_match_inner_tag_flag = true;
                                    if (all_tags.length) {
                                        all_tags.map((i, e) => {
                                            target_tag = $(e).find('.reduction-code')?.find('span')?.first()?.text();
                                            target_tag = target_tag && target_tag.substr(target_tag.length - 4).toLowerCase();
                                            if (code_last4 == target_tag) {
                                                $(e).find('.tag__wrapper').find('.tag__button').click();
                                                no_match_tag_flag = false;
                                                let test_int = setInterval(() => {
                                                    let inner_all_tags = $('.order-summary__section--discount .tags-list .tag');
                                                    inner_all_tags.map((ii, ee) => {
                                                        inner_target_tag = $(ee).find('.reduction-code')?.find('span')?.first()?.text();
                                                        inner_target_tag = inner_target_tag && inner_target_tag.substr(inner_target_tag.length - 4).toLowerCase();
                                                        if (code_last4 == inner_target_tag && no_match_inner_tag_flag) {
                                                            no_match_inner_tag_flag = false;
                                                        }
                                                    })
                                                    if (no_match_inner_tag_flag) {
                                                        after_func(ajax_resCode);
                                                        clearInterval(test_int);
                                                    }
                                                    no_match_inner_tag_flag = true;

                                                }, 100)
                                                setTimeout(() => {
                                                    clearInterval(test_int)
                                                }, 10000);
                                            }
                                        })
                                    }
                                    if (no_match_tag_flag) {
                                        after_func(ajax_resCode);
                                    }
                                } else {
                                    after_func(ajax_resCode);
                                }
                            } else {
                                after_func(ajax_resCode);
                            }
                        },
                        error: err => {
                            if (err.status == 404 || err.status == 400 || err.statusText == 'error') {
                                let temp_err_msg = '';
                                if (err?.responseJSON?.error_code == '5124') {
                                    temp_err_msg = 'The gift card is locked, please try again later';
                                }
                                else if(err?.responseJSON?.error_code == '5065'){
                                    temp_err_msg = 'The gift card has expired';
                                }
                                else {
                                    temp_err_msg = 'Enter a valid gift card';
                                }
                                $('.checkout-giftCard-container .checkout-giftCard-error')[0].innerText = temp_err_msg;
                                $('.checkout-giftCard-cardInput').val('');
                                $('.checkout-giftCard-pinInput').val('');
                                $('.checkout-giftCard-cardInput').prop('disabled', false);
                                $('.checkout-giftCard-pinInput').prop('disabled', false);
                                $('#checkout-giftCard-btn').removeClass('btn-submitting');
                                $('.checkout-giftCard-container').removeClass('btn-submitting');
                                $('.checkout-giftCard-inputContainer .checkout-giftCard-cardInput').removeClass('show-label');
                                $('.checkout-giftCard-inputContainer .checkout-giftCard-label').removeClass('show-label');
                                $('.checkout-giftCard-pinInputContainer .checkout-giftCard-pinInput').removeClass('show-label');
                                $('.checkout-giftCard-pinInputContainer .checkout-giftCard-label').removeClass('show-label');
                                $('.checkout-giftCard-inputContainer .checkout-giftCard-cardInput').attr('placeholder', 'Gift Card No.');
                                $('.checkout-giftCard-pinInputContainer .checkout-giftCard-pinInput').attr('placeholder', '4 Digit PIN');
                                enableDisableGiftCardBtn();
                            }
                        }
                    })
                })
            }

            // addPromoCodeForm
            // add dummy 'promo code' form section
            // and bind all its related funcs
            function addPromoCodeForm() {
                let promo_code_form = `
                        <form id="checkout-ap21-promoCode-form">
                            <div class="checkout-giftCard-container checkout-promoCode-container" data-flag="initial">
                                <div class="checkout-giftCard-title">Apply Promo Code</div>
                                <div class="checkout-giftCard-inputBtnContainer">
                                    <div class="checkout-giftCard-pinInputContainer">
                                        <input class="checkout-giftCard-input checkout-promoCode-codeInput" placeholder="Discount Code" type="text" />
                                        <label class="checkout-giftCard-label">Discount Code</label>
                                    </div>
                                        <button id="checkout-promoCode-btn" class="checkout-giftCard-btn" disabled>
                                            <span class="checkout-promoCode-btnContent">Apply</span>
                                            <svg class="icon-svg icon-svg--size-18 btn__spinner icon-svg--spinner-button" aria-hidden="true" focusable="false"> <use xlink:href="#spinner-button"></use> </svg>
                                            <svg class="icon-svg icon-svg--size-16 btn__icon shown-on-mobile" aria-hidden="true" focusable="false"> <use xlink:href="#arrow"></use> </svg>
                                        </button>
                                </div>
                                <div class="checkout-giftCard-msgContainer">
                                    <p class="checkout-promoCode-error"></p>
                                </div>
                            </div>
                        </form>
                `;

                $('#checkout-giftCard-section').append(promo_code_form);
                $('.checkout-promoCode-codeInput').on('keydown', debounce(e => {
                    showInputLabel(e);
                    enableDisablePromoCodeBtn(e)
                }, 150))

                $('.checkout-promoCode-codeInput').on('blur', e => {
                    hideInputLabel(e, 'codeInput');
                });
            }

            // enableDisablePromoCodeBtn
            // enable or disbale dummy 'promo code' form section's submit btn
            function enableDisablePromoCodeBtn(e) {
                let code_val = $('.checkout-promoCode-codeInput').val();
                let btn_apply = $('#checkout-promoCode-btn');

                if (!!code_val) {
                    btn_apply.prop('disabled', false);
                } else {
                    btn_apply.prop('disabled', true);
                }
            }

            // submitPromoCode
            // submit dummy 'promo code' form 
            // if its valid, then apply the return code to checkout
            // if its not valid, then show error msg
            function submitPromoCode() {
                $('body').on('submit', '#checkout-ap21-promoCode-form', e => {
                    e.preventDefault();
                    $('#checkout-promoCode-btn').addClass('btn-submitting');
                    $('.checkout-promoCode-container').addClass('btn-submitting');
                    $('.checkout-promoCode-codeInput').prop('disabled', true);
                    $('.checkout-promoCode-container .checkout-promoCode-error')[0].innerText = '';
                    let code_val = $('.checkout-promoCode-codeInput').val();

                    if (code_val) {
                        $('#checkout_reduction_code').val(code_val)
                        $('.order-summary__section--discount .edit_checkout .field__input-btn').prop('disabled', false);
                        $('.order-summary__section--discount .edit_checkout .field__input-btn').click();
                        promoCodeAfterSubmit(code_val);
                    }
                })
            }

            // promoCodeAfterSubmit
            // after submit dummy 'promo code' form section
            // will check its inputs, labels, placeholders, and error msg
            // and enable/disable its btn
            function promoCodeAfterSubmit(temp_code) {
                let temp_interval = setInterval(() => {
                    if (!$('.order-summary__section--discount .edit_checkout .field__input-btn').hasClass('btn--loading')) {
                        let error_msg = $('#error-for-reduction_code').length && $('#error-for-reduction_code')[0]?.innerText.replace(/ or gift card/, '');
                        $('.checkout-promoCode-container .checkout-promoCode-error')[0].innerText = error_msg ? error_msg : '';

                        $('.checkout-promoCode-codeInput').prop('disabled', false);

                        $('.checkout-promoCode-codeInput').val('');
                        $('.checkout-promoCode-codeInput').attr('placeholder', 'Discount Code');
                        $('.checkout-promoCode-codeInput').removeClass('show-label');
                        $('.checkout-promoCode-codeInput').next().removeClass('show-label');

                        $('#checkout-promoCode-btn').removeClass('btn-submitting');
                        $('.checkout-promoCode-container').removeClass('btn-submitting');
                        enableDisablePromoCodeBtn();
                        clearInterval(temp_interval);
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(temp_interval)
                }, 10000);
            }

            $('.order-summary__section.order-summary__section--discount').after('<div id="checkout-giftCard-section"></div>');
            $('.step__sections .section').first().find('.content-box').after('<div id="checkout-giftCard-mobileSection"></div>');
            checkout();
        })(Checkout.$)
    }
    else{
        (function ($) {
            const $checkBalanceModule = $("[data-mrap21giftcard-module='checkBalance']");
            const $productFormModule = $("[data-mrap21giftcard-module='productForm']");
            if ($checkBalanceModule.length) {
                $checkBalanceModule.append(`
          <form class="mr-ap21-giftcard-checkBalance-form">
              <div><input name="number" placeholder="Gift Voucher Number" required></div>
              <div><input name="pin" type="number" placeholder="Pin Number" required></div><button>Check
                  balance</button>
          </form>
        `);
                $('form.mr-ap21-giftcard-checkBalance-form').on('submit', function (e) {
                    if(!$(this).get(0).reportValidity()){
                        return false;
                    }
                    e.preventDefault();
                    const $form = $(this);
                    const target_url = `https://we82o2s2ab.execute-api.ap-southeast-2.amazonaws.com/development/public/v1/giftcard`;
                    const store = "";
                    const currency = "";
                    const params = {
                        "store_id": store.split('.')[0],
                        "voucher_number": $(this).find('input[name="number"]').val(),
                        "pin": $(this).find('input[name="pin"]').val(),
                        "currency": currency
                    }
                    $.ajax({
                        method: 'GET',
                        url: target_url,
                        data: params,
                        success: res => {
                            $('.mr-ap21-giftcard-checkBalance-msg').detach()
                            const msg = `Your voucher balance is $${res.balance.toFixed(2)}`;
                            const $msgElement = $form.find('.mr-ap21-giftcard-checkBalance-success');
                            if ($msgElement.length) {
                                $msgElement.html(errMsg);
                            }
                            else {
                                $form.prepend(`<div class="mr-ap21-giftcard-checkBalance-msg mr-ap21-giftcard-checkBalance-success">${msg}</div>`)
                            }
                        },
                        error: err => {
                            $('.mr-ap21-giftcard-checkBalance-msg').detach()
                            if (err.status == 404 || err.statusText == 'error') {
                                const errMsg = 'Gift card number or PIN is incorrect';
                                const $errElement = $form.find('.mr-ap21-giftcard-checkBalance-error');
                                if ($errElement.length) {
                                    $errElement.html(errMsg);
                                }
                                else {
                                    $form.prepend(`<div class="mr-ap21-giftcard-checkBalance-msg mr-ap21-giftcard-checkBalance-error">${errMsg}</div>`)
                                }
                            }
                        }
                    });
                })
            }
            if ($productFormModule.length > 0) {
                $productFormModule.html(`
          <p class="line-item-property__field">
            <label for="sender-name">YOUR FIRST NAME</label>
            <input id="sender-name" type="text" name="properties[SENDER NAME]">
          </p>

          <p class="line-item-property__field line-item-property__field-name">
            <label for="recipient-name">RECIPIENT'S NAME</label>
            <input required class="required" id="recipient-name" type="text" name="properties[RECIPIENT NAME]">
          </p>

          <p class="line-item-property__field line-item-property__field-email">
            <label for="recipient-email">RECIPIENT'S EMAIL</label>
            <input required class="required" id="recipient-email" type="email" name="properties[RECIPIENT EMAIL]">
          </p>

          <p class="line-item-property__field line-item-property__field-email-confirm">
            <label for="recipient-email-confirm">CONFIRM RECIPIENT'S EMAIL</label>
            <input required class="required" id="recipient-email-confirm" type="email">
          </p>

          <p class="line-item-property__field">
            <label for="message">PERSONALISED MESSAGE</label>
            <textarea id="message" name="properties[MESSAGE]" maxlength="250"></textarea>
            <span class="character-count"><span>250</span> characters remaining</span>
          </p>
        `)

            const giftCardInput = $('.template-gift-cards [data-mrap21giftcard-module="productForm"] input');
            const giftCardMessage = $('.template-gift-cards [data-mrap21giftcard-module="productForm"] textarea');

            giftCardInput.on('focusout', () => {
                validateGiftForm();
            })

            giftCardMessage.on('focusout', () => {
                validateGiftForm();
            })

            giftCardMessage.on('keyup', () => {
                let characterCount = giftCardMessage.val().length;
                let characterCountLeft = 250 - characterCount;
                $('.template-gift-cards .character-count span').text(characterCountLeft);
            })

            function validateGiftForm() {                    
                if ($('#sender-name').val().length > 0 && $('#recipient-name').val().length > 0 && $('#recipient-email').val().length > 0 && $('#recipient-email-confirm').val().length > 0 && $('#message').val().length > 0) {
                    $('.template-gift-cards .product-form__submit').removeAttr('disabled');
                }
                else {
                    $('.template-gift-cards .product-form__submit').attr('disabled', true);
                }
            }

            }
        })(jQuery)

    }
